import React from 'react';

const AssignmentActionsTab = ({ complaint }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const getAssignedTo = () => {
    if (!complaint.assignment) return 'Not Assigned';
    if (typeof complaint.assignment === 'string') return complaint.assignment;
    if (complaint.assignment.assigned_to) {
      if (typeof complaint.assignment.assigned_to === 'string') return complaint.assignment.assigned_to;
      if (complaint.assignment.assigned_to.name) return complaint.assignment.assigned_to.name;
    }
    return 'Not Assigned';
  };

  const getAssignedBy = () => {
    if (!complaint.assignment) return 'N/A';
    if (complaint.assignment.assigned_by) {
      if (typeof complaint.assignment.assigned_by === 'string') return complaint.assignment.assigned_by;
      if (complaint.assignment.assigned_by.name) return complaint.assignment.assigned_by.name;
    }
    return 'N/A';
  };

  const getAssignmentDate = () => {
    if (!complaint.assignment) return null;
    return complaint.assignment.assigned_at || complaint.assignment.created_at;
  };

  const getAssignmentNotes = () => {
    if (!complaint.assignment) return 'No assignment notes';
    return complaint.assignment.notes || complaint.assignment.remarks || 'No assignment notes';
  };

  const getActionBy = () => {
    if (!complaint.action) return 'No action taken';
    if (complaint.action.action_by) {
      if (typeof complaint.action.action_by === 'string') return complaint.action.action_by;
      if (complaint.action.action_by.name) return complaint.action.action_by.name;
    }
    return 'Unknown';
  };

  const getActionDate = () => {
    if (!complaint.action) return null;
    return complaint.action.action_date || complaint.action.created_at;
  };

  const getActionNotes = () => {
    if (!complaint.action) return 'No action notes';
    return complaint.action.action_note || complaint.action.notes || 'No action notes';
  };

  return (
    <div className="space-y-6">
      {/* ASSIGNMENT SECTION */}
      <div>
        <h3 className="text-sm font-medium text-gray-700 mb-3">ASSIGNMENT</h3>
        
        <div className="bg-gray-50 rounded-lg p-4 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Assigned To
              </label>
              <p className="text-sm text-gray-900">
                {getAssignedTo()}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Assigned By
              </label>
              <p className="text-sm text-gray-900">
                {getAssignedBy()}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date of Assignment
              </label>
              <p className="text-sm text-gray-900">
                {formatDate(getAssignmentDate())}
              </p>
            </div>
          </div>

          {/* Assignment Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Remarks
            </label>
            <p className="text-sm text-gray-900">
              {getAssignmentNotes()}
            </p>
          </div>
        </div>
      </div>

      {/* ACTION SECTION */}
      <div>
        <h3 className="text-sm font-medium text-gray-700 mb-3">ACTION</h3>
        
        <div className="bg-gray-50 rounded-lg p-4 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Action By
              </label>
              <p className="text-sm text-gray-900">
                {getActionBy()}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date of Action
              </label>
              <p className="text-sm text-gray-900">
                {formatDate(getActionDate())}
              </p>
            </div>
          </div>

          {/* Action Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Action Notes
            </label>
            <p className="text-sm text-gray-900">
              {getActionNotes()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentActionsTab;